// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages----privacy_policy-module---container---1Lu-h","normal_text":"src-pages----privacy_policy-module---normal_text---35TgB","main_heading":"src-pages----privacy_policy-module---main_heading---3nTAL","sec_heading":"src-pages----privacy_policy-module---sec_heading---3a3G0","under_sec_heading":"src-pages----privacy_policy-module---under_sec_heading---1rdWl","ite_heading":"src-pages----privacy_policy-module---ite_heading---llX5O","indent":"src-pages----privacy_policy-module---indent---3OQ6S"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/privacy_policy.module.scss
// module id = 253
// module chunks = 15400075347947